import * as React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import Logo from "theme/components/common/Logo";

/**
 * A single card in the middle of the page, like the login page, for pages
 * shown whether or not the user is logged in (e.g. confirming a login from a
 * link) or while the session may do nothing else (setting up MFA)
 */
const CenteredLayout: React.FC = () => (
  <div className="container py-0">
    <Row className="flex-center min-vh-100 py-6">
      <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5">
        <Logo />
        <Card>
          <Card.Body className="px-3 py-4 p-sm-5">
            <Outlet />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </div>
);

export default CenteredLayout;
